// extracted by mini-css-extract-plugin
module.exports = {"container":"tournamentItem__container___h2WLn","title":"tournamentItem__title___vevMH","counter":"tournamentItem__counter___2_Beu"};